import { Type } from 'class-transformer';
import {
  IsBoolean,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
} from 'class-validator';

export class ValidatorGroup {
  @IsString()
  @IsNotEmpty()
  vacationType: string;

  @IsNumber()
  @Type(() => Number)
  @IsOptional()
  minDurationDays?: number;

  @IsString()
  @IsNotEmpty()
  minDurationUnit: string;

  @IsBoolean()
  @IsOptional()
  minDuration?: boolean;

  @IsNumber()
  @Type(() => Number)
  @IsOptional()
  maxDurationDays?: number;

  @IsString()
  @IsNotEmpty()
  maxDurationUnit: string;

  @IsBoolean()
  @IsOptional()
  maxDuration?: boolean;

  @IsBoolean()
  @IsOptional()
  mustSchedule14days?: boolean;

  @IsBoolean()
  @IsOptional()
  min5DaysBetweenNotWorkdays?: boolean;

  @IsBoolean()
  @IsOptional()
  minSpecificWeekendDays?: boolean;
}
